import { l as layout } from "./layout-store.js";
import "./preact-core.js";
class ClickToOpen extends HTMLElement {
  constructor() {
    super();
    this.paramsOpened = false;
    this.visible = false;
    this.isOpen = true;
    this.layout = layout;
    this.backdropEl = this.querySelector(".__backdrop");
    this.closeEl = this.querySelector(".close");
    this.connectedCallback();
  }
  connectedCallback() {
    this.externalTriggers = document.querySelectorAll(
      `a[href="#${this.id}"], [data-target="${this.id}"], a[href^="#${this.id}?"]`
    );
    this.externalClose = document.querySelectorAll(`[data-close="${this.id}"]`);
    this.externalTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.open();
      });
    });
    this.externalClose.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.close();
      });
    });
    [this.backdropEl, this.closeEl].forEach((trigger) => {
      if (trigger) {
        trigger.addEventListener("click", () => {
          this.close();
        });
        trigger.addEventListener("touchstart", () => {
          this.close();
        });
      }
    });
    document.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.addEventListener("transitionend", () => {
      this.visible = this.isOpen ? true : false;
    });
    this.openOnQueryParam();
  }
  open() {
    this.dispatchEvent(new Event("open", { bubbles: true, composed: true }));
  }
  close() {
    this.dispatchEvent(new Event("close", { bubbles: true, composed: true }));
  }
  openOnQueryParam() {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.replace("#", "");
      if (hash == this.id && !this.isOpen && !this.paramsOpened) {
        this.open();
        this.paramsOpened = true;
      }
    }
  }
}
customElements.define("click-to-open", ClickToOpen);
export {
  ClickToOpen as default
};
